import { graphql } from "../gql";

export const GetScansQuery = graphql(`
  query me {
    me {
      id
      email
      fitSessions {
        createdAt
        scanID
        previousPurchaseID
        fitSessionType
      }
    }
  }
`);
